import React, { useState, useEffect } from "react";
import styles from "./Ecom.module.css";
import { useNavigate } from "react-router-dom";
import { listAllCategories, listAllProducts } from "../../Api/Ecom";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";

function Ecom() {
  const [activeTab, setActiveTab] = useState("used"); // 'new' or 'used'
  const [displayCount, setDisplayCount] = useState(4);
  const [categories, setCategories] = useState([]);
  const [ecomData, setEcomData] = useState({
    products: [],
    priorityVendors: [
      {
        categories: [],
      },
    ],
  });
  const [searchTerm, setSearchTerm] = useState("");
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();
  const token = useSelector((state) => state.login.token);

  const getAllProducts = async (searchTerm = undefined) => {
    try {
      setLoading(true);
      const params = {
        search: searchTerm,
        page: 1,
        limit: 10000,
        isNew: activeTab === "new" ? 1 : 0,
      };
      const response = await listAllProducts(token, params);
      setEcomData(response.data);
    } catch (error) {
      toast.error(error.message);
      throw error;
    }
  };

  useEffect(() => {
    const handleResize = () => {
      setDisplayCount(window.innerWidth <= 640 ? 2 : 6);
    };
    // Set initial value
    handleResize();

    const getAllCategories = async () => {
      try {
        const response = await listAllCategories(token);
        setCategories(response.data);
      } catch (error) {
        toast.error(error.message);
        throw error;
      }
    };

    // const getWishlist = async () => {
    //   try {
    //     const response = await getWishlist(token);
    //     setActiveWishlist(response.data.productId);
    //   } catch (error) {
    //     toast.error(error.message);
    //     throw error;
    //   }
    // };    

    // getWishlist();
    getAllCategories();

    getAllProducts();
  }, [searchTerm, activeTab]);

  const handleSearchInputChange = (e) => {
    e.preventDefault();

    setSearchTerm(e.target.value);
    getAllProducts(searchTerm);
  };

  const viewCategoryPage = (vendorIdArray) => {
    if (vendorIdArray && vendorIdArray.length > 0) {
      const vendorId = vendorIdArray[0]; // Safely extract the first vendorId
      navigate("/ecomcategory", { state: { vendorId } });
    } else {
      console.error("Vendor ID array is empty or undefined");
      toast.error("No Vendor  found");
    }
  };

  const handleManageInventory = () => {
    navigate("/manageInventory");
  };

  // navigate to wishlist page
  const navigateToWishlistPage = () => {
    navigate("/wishlist");
    console.log("wishlist");
  };

  // navigate to category page
  const navigateToCategoryPage = (product, vendor) => {
    navigate("/ecominventory", {
      state: {
        categoryId: product.categoryId,
        vendorId: vendor.vendorId,
      },
    });
  };

  // add wishlist
  const handleWishlist = async (productId) => {
    try {
      // const response = await addToWishlist(token, productId);
      console.log(productId);
     
    } catch (error) {
      toast.error(error.message);
      throw error;
    }
  };

  return (
    <div className={styles.container}>
      <div className={styles.categoriesContainer}>
        <div className={styles.phonemanageInventory}>
          <span>Home</span>
          <button
            className={styles.sellUsedItem}
            onClick={handleManageInventory}
          >
            Manage Inventory
          </button>
          
         
        </div>

        {/* Toggle Buttons */}
        <div className={styles.toggleContainer}>
          <button
            className={`${styles.toggleButton} ${
              activeTab === "new" ? styles.activeToggle : ""
            }`}
            onClick={() => setActiveTab("new")}
          >
            New Items
          </button>
          <button
            className={`${styles.toggleButton} ${
              activeTab === "used" ? styles.activeToggle : ""
            }`}
            onClick={() => setActiveTab("used")}
          >
            Used Items
          </button>
        </div>
        <div className={styles.tab1}>
          <div className={styles.searchContainer}>
            <form
              className={`d-flex ${styles.search}`}
              onSubmit={(e) => e.preventDefault()}
            >
              <input
                className={`form-control text-custom me-2 w-30 ${styles.textCustom}`}
                type="search"
                placeholder="Search"
                aria-label="Search"
                onChange={handleSearchInputChange}
                value={searchTerm}
              />
            </form>
          </div>

          <div className={styles.manageInventory}>
            <button
              className={styles.sellUsedItem}
              onClick={handleManageInventory}
            >
              Manage Inventory
            </button>
           
          </div>
        </div>
      </div>
      <div className={styles.cardContainer}>
        {/* Categories Scroll */}
        <div className={styles.categoriesList}>
          {categories.map((category) => (
            <div
              key={category.id}
              className={styles.categoryItem}
              onClick={() =>
                navigate("/ecominventory", {
                  state: {
                    categoryId: category.id,
                    showAllCategories: "true",
                  },
                })
              }
            >
              <div className={styles.categoryImage}>
                <img src={category.img} alt={category.name} />
              </div>
              <span className={styles.categoryName}>{category.name}</span>
            </div>
          ))}
        </div>

        {/* Store Header */}
        <div className={styles.phonetoggleContainer}>
          <button
            className={`${styles.toggleButton} ${
              activeTab === "new" ? styles.activeToggle : ""
            }`}
            onClick={() => setActiveTab("new")}
          >
            New Items
          </button>
          <button
            className={`${styles.toggleButton} ${
              activeTab === "used" ? styles.activeToggle : ""
            }`}
            onClick={() => setActiveTab("used")}
          >
            Used Items
          </button>
        </div>
        <div className={styles.phonetab1}>
          <div className={styles.searchContainer}>
            <form
              className={`d-flex ${styles.search}`}
              onSubmit={(e) => e.preventDefault()}
            >
              <input
                className={`form-control text-custom me-2 w-30 ${styles.textCustom}`}
                type="search"
                placeholder="Search"
                aria-label="Search"
                onChange={handleSearchInputChange}
                value={searchTerm}
              />
            </form>
          </div>

          <div className={styles.manageInventory}>
            <button
              className={styles.sellUsedItem}
              onClick={handleManageInventory}
            >
              Manage Inventory
            </button>
          
          </div>
        </div>
        {ecomData.priorityVendors.map((vendor) => (
          <div className={styles.storeContainer}>
            <div className={styles.storeHeader}>
              <h2 className={styles.storeName}>{vendor.storeName}</h2>

              <button
                className={styles.viewShopButton}
                onClick={() =>
                  viewCategoryPage(
                    ecomData.priorityVendors.map((e) => e.vendorId)
                  )
                }
              >
                View Shop
              </button>
            </div>
            <div className={styles.storeCategoryContainer}>
              {vendor.categories
                .slice(0, displayCount)
                .map((product, index) => (
                  <div key={product.id} className={styles.productCardadd}>
                    <img
                      src={product.categoryImg}
                      alt={product.categoryName}
                      className={styles.productImageadd}
                    />
                    <h3 className={styles.productName}>
                      {product.categoryName}
                    </h3>
                    <div className={styles.viewDetailsButtonadd}>
                      <button
                        onClick={() => navigateToCategoryPage(product, vendor)}
                      >
                        View More
                      </button>
                    </div>
                  </div>
                ))}
            </div>
          </div>
        ))}
        {/* Product Grid */}
        <div className={styles.productGrid}>
          {ecomData.products.map((product) => (
            <div key={product.id} className={styles.productCard}>
             
              
               
              <img
                src={product.mainImage}
                alt={product.name}
                className={styles.productImage}
              />
              <h3 className={styles.productName}>{product.productName}</h3>
              <div className={styles.priceContainer}>
                <span className={styles.originalPrice}>₹{product.price}</span>
                <span className={styles.discountedPrice}>
                  ₹{product.discountedPrice}
                </span>
                <span className={styles.discount}>{product.discount}</span>
              </div>
              {product.averageRating !== null ? (
                <div className={styles.ratingContainer}>
                  <span className={styles.star}>★</span>
                  <span className={styles.rating}>
                    {product.averageRating}/5
                  </span>
                </div>
              ) : (
                <span className={styles.rating}> Review Not Posted</span>
              )}
              <button
                className={styles.viewDetailsButton}
                onClick={() =>
                  navigate(`/ecominventorydetail `, {
                    state: { productId: product.id },
                  })
                }
              >
                View Details
              </button>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default Ecom;
